export const footerInformationLinks = [
  { to: "/main-page", label: "One Platform" },
  { to: "/about-page", label: "About Us" },
  { to: "/services", label: "Services" },
  { to: "/vendors-delivery-partners", label: "Vendors & Delivery Partners" },
  { to: "/free-delivery", label: "Free Delivery" },
  { to: "/returns-policy", label: "Returns Policy" },
  { to: "/terms-and-conditions", label: "Terms & Conditions" },
  { to: "/privacy-policy", label: "Privacy Policy" },
];

export const footerCustomerSupportLinks = [
  { to: "/help-center", label: "Help Center" },
  { to: "/contact-us", label: "Contact Us" },
  { to: "/advertise-with-us", label: "Advertise With Us" },
  { to: "/become-a-delivery-partner", label: "Become a Delivery Partner" },
  { to: "/onboard-your-store", label: "Onboard Your Store" },
];
